import { NgZone, OnInit, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'
import { } from 'googlemaps';
import { UserService, CookieService, MyCartService } from '../_services/index';

declare var $: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'ordersummary.component.html',
    styleUrls: ['ordersummary.component.css']
})
export class OrdersummaryComponent implements OnInit {
    summaryData: any

    constructor(private router: Router, private ngZone: NgZone, private userService: UserService, private cookieService: CookieService, private myCartService: MyCartService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
    }

    ngOnInit() {
        if (this.cookieService.getCookie('orderSummary')) {
            let order = this.cookieService.getCookie('orderSummary');
            if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
                let ID = this.cookieService.getCookie('customerID');
                let sessionKey = this.cookieService.getCookie("sessionKey");
                this.myCartService.getorderSummary(ID, order, sessionKey).subscribe(result => {
                    this.ngZone.run(() => {
                        let ifrm = $('#iframe1')[0];
                        ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
                        ifrm.document.open();
                        ifrm.document.write(result);
                        ifrm.document.close();
                        this.summaryData = result
                    })
                });
            }
        }
    }
}
